import * as React from "react";
import { PropsWithChildren, useEffect, useMemo, useState } from "react";
import { LocationContext } from "./LocationContext";
import { Path } from "react-router-dom";

export const KidsLocationProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { pathname, search, hash } = window.location;
  const [path, setPath] = useState<Path>({ pathname, search, hash });
  useEffect(() => {
    const handleHashChange = () => {
      const { pathname, search, hash } = window.location;
      setPath({ pathname, search, hash });
    };
    // LS2Kids uses 100% hash based routing
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <LocationContext.Provider value={path}>{children}</LocationContext.Provider>
  );
};
